import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store, { storeKey } from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import VueGoogleMaps from "@fawmi/vue-google-maps";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import "bootstrap";
import { Mapkey } from "./util/googlemap";

const app = createApp(App);

app.use(store, storeKey);
app.use(router);
app.use(ElementPlus);
app.use(VueGoogleMaps, {
  load: {
    key: Mapkey,
    language: "id",
    libraries: "places",
  },
});

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
